<template>
    <b-modal ref="mdlEditTipoImpegnativa" id="mdlEditTipoImpegnativa" :title="title" size="lg" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <b-row>
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Tipo</label>
                <b-form-input v-model="jsonDataTipoImpegnativa.tipo" placeholder="Inserire tipo impegnativa..."></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                <label class="sa-label-data">Codice Flusso</label>
                <b-form-input v-model="jsonDataTipoImpegnativa.codiceFlusso" placeholder="Inserire codice flusso impegnativa..."></b-form-input>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button @click="onCloseModal" variant="outline-danger" size="md">Annulla</b-button>
            <b-button @click="onSaveTipoImpegnativa" variant="outline-success" size="md">Salva</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";

export default {
    name: "RsaConfigurazioneTipoImpegnativaEdit",
    components: { ModalError },
    mixins: [UtilityMixin],
    data() {
        return {
            title: null,
            pathResource: "/rsaimpegnativatipo",
            jsonDataTipoImpegnativa: {
                tipo: null,
                codiceFlusso: null,
            },
        };
    },
    methods: {
        show(jsonData) {
            let me = this;
            me.jsonDataTipoImpegnativa = jsonData;
            me.title = !jsonData.id ? "Nuova Impegnativa" : "Aggiorna Impegnativa";
            me.$refs.mdlEditTipoImpegnativa.show();
        },
        onCloseModal() {
            let me = this;
            me.jsonDataTipoImpegnativa = {
                tipo: null,
                codiceFlusso: null,
            };
            me.$refs.mdlEditTipoImpegnativa.hide();
            me.$emit("onClose");
        },
        onSaveTipoImpegnativa() {
            let me = this;
            UtilityMixin.methods.saveResource(me.pathResource, me.jsonDataTipoImpegnativa, me.saveTipoImpegnativaSuccess, me.saveTipoImpegnativaError);
        },
        saveTipoImpegnativaSuccess(response) {
            let me = this;
            me.$emit("onSave", response);
            me.$refs.mdlEditTipoImpegnativa.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        saveTipoImpegnativaError(error) {
            let me = this;
            me.$refs.cmpModalError.show(error.response.data.messaggio);
        },
        deleteImpegnativa(id) {
            let me = this;
            UtilityMixin.methods.deleteResource(me.pathResource + "/" + id, null, me.deleteTipoImpegnativaSuccess, me.deleteTipoImpegnativaError);
        },
        deleteTipoImpegnativaSuccess(response) {
            let me = this;
            me.$emit("deleteImpegnativa", response);
            me.$bvToast.toast("Eliminazione avvenuta con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
        deleteTipoImpegnativaError(response) {
            let me = this;
            me.$emit("deleteImpegnativa", response);
            me.$bvToast.toast("Errore durante l'eliminazione", {
                title: "Errore,",
                variant: "danger",
                solid: true,
            });
        },
        onDeleteImpegnativa(item) {
            let me = this;
            me.$bvModal
                .msgBoxConfirm("Sei sicuro di voler eliminare questa impegnativa?", {
                    title: "Eliminazione impegnativa",
                    buttonSize: "sm",
                    okTitle: "SI",
                    cancelTitle: "NO",
                    okVariant: "danger",
                    cancelVariant: "secondary",
                    hideHeaderClose: true,
                    footerClass: "p-2",
                    centered: true,
                })
                .then((value) => {
                    if (value) {
                        me.deleteImpegnativa(item.id);
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
</script>
